const prod = {
	url: {
		API_HOST: "https://comichq-api.pedroalcala.com",
	},
};

const dev = {
	url: {
		API_HOST: "http://localhost:8080",
	},
};

export const config = process.env.NODE_ENV === "development" ? dev : prod;
